export default __webpack_public_path__ + "static/media/14_2D38X5R-min.7db028eb.jpg";